var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.$store.get('enrollment/selected@kelon_group_id'))?_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('kelon-video')],1):_vm._e(),_c('v-col',[_c('tryout-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }